import createReducer from '../../helpers/CreateReducer';
import { ApiConstants, PaymentsConstants } from '../../constants/actions';

interface PaymentMethodsState {
  paymentMethods: any[];
  locale: string;
  amount: number;
  isLoading: boolean;
  loaded: boolean;
  noPersistance: boolean;
  isError: boolean;
}

export const getInitialState = (): PaymentMethodsState => ({
  paymentMethods: [],
  locale: '',
  amount: 0,
  isLoading: false,
  loaded: false,
  noPersistance: true,
  isError: false
});

interface LoadPaymentMethodsRequestAction {
  locale: string;
  totalAmount: number;
}

interface LoadPaymentMethodsSuccessAction {
  methods: any[];
}

export default createReducer(getInitialState, {
  [`${ApiConstants.LOAD_PAYMENT_METHODS}_REQUEST`]: (
    state: PaymentMethodsState,
    { locale, totalAmount }: LoadPaymentMethodsRequestAction
  ) => ({
    paymentMethods: [],
    locale,
    amount: totalAmount,
    isLoading: true,
    loaded: false
  }),
  [`${ApiConstants.LOAD_PAYMENT_METHODS}_SUCCESS`]: (
    state: PaymentMethodsState,
    { methods }: LoadPaymentMethodsSuccessAction
  ) => ({
    paymentMethods: methods,
    isLoading: false,
    loaded: true
  }),

  [`${ApiConstants.LOAD_PAYMENT_METHODS}_FAILURE`]: () => ({
    ...getInitialState(),
    isLoading: false,
    loaded: true,
    isError: true
  }),

  [`${PaymentsConstants.RESET_PAYMENT_METHODS_QUERY_PARAMETERS}`]: () => ({
    ...getInitialState()
  })
});
